import React from 'react';
import { useTranslation } from 'react-i18next';

import logo from '../../../assets/logo.svg';
import { Image, Link } from './styles';

export default function Logo({ className, fullWidth, imgComponent: ImageComponent = Image }) {
  const { t } = useTranslation();

  return (
    <Link fullWidth={fullWidth} className={className} href="/" color="secondary">
      <ImageComponent src={logo} alt={t('logo.title')} />
    </Link>
  );
}
